export const RICH_TEXT_MODE_STORAGE_KEY = "CHAT_RICH_TEXT_MODE";
